import { render, staticRenderFns } from "./RunDetails.vue?vue&type=template&id=6efa0edd&"
import script from "./RunDetails.vue?vue&type=script&lang=js&"
export * from "./RunDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports